import React from "react";
import { observer } from "mobx-react";
import UiMeet3dHomePage from "~/modules/UiMeet3d/app/UiMeet3dHomePage";
import "../styles/TourIndexHeader.less";
import "../styles/SidePage.less";
import "../styles/TourLayout.less";

const ClientPanelUiMeet3dHomePage = observer(props => <UiMeet3dHomePage {...props} />);

export default ClientPanelUiMeet3dHomePage;
